import { render } from "./choiceDeskModel.vue?vue&type=template&id=357b44bd"
import script from "./choiceDeskModel.vue?vue&type=script&lang=js"
export * from "./choiceDeskModel.vue?vue&type=script&lang=js"

import "./choiceDeskModel.vue?vue&type=style&index=0&id=357b44bd&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__